import { render, staticRenderFns } from "./ProxyMigrateCDP.vue?vue&type=template&id=5212d8f6&scoped=true&"
import script from "./ProxyMigrateCDP.vue?vue&type=script&lang=js&"
export * from "./ProxyMigrateCDP.vue?vue&type=script&lang=js&"
import style0 from "./ProxyMigrateCDP.vue?vue&type=style&index=0&id=5212d8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212d8f6",
  null
  
)

export default component.exports